import { render } from "./SlideOutPanel.vue?vue&type=template&id=56c4643c&scoped=true"
import script from "./SlideOutPanel.js?vue&type=script&lang=js&external"
export * from "./SlideOutPanel.js?vue&type=script&lang=js&external"

import "./SlideOutPanel.vue?vue&type=style&index=0&id=56c4643c&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c4643c"],['__file',"src/Components/ChatWidget/SlideOutPanel/SlideOutPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56c4643c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56c4643c', __exports__)) {
    api.reload('56c4643c', __exports__)
  }
  
  module.hot.accept("./SlideOutPanel.vue?vue&type=template&id=56c4643c&scoped=true", () => {
    api.rerender('56c4643c', render)
  })

}


export default __exports__